import { Alert, Typography } from 'omakase';
import { core } from '@tock/coretypes';

interface ReceiptCalloutsProps {
  purchase?: core.PastPurchase;
  ticketType?: core.ITicketType;
  businessName?: core.Business['name'];
}

export const ReceiptCallouts = ({ ticketType, businessName, purchase }: ReceiptCalloutsProps) => {
  const isDelivery = ticketType?.variety === 'ORDER_DELIVERY';
  const isPickup = ticketType?.variety === 'ORDER_PICKUP';
  const reserveShippingTime = ticketType?.reserveShippingTime;

  return (
    <>
      {purchase?.cancelledOrRefunded && (
        <Alert withoutIcon data-testid="receipt-label">
          Reservation canceled
        </Alert>
      )}
      {purchase?.isTransferredFrom && !purchase?.cancelledOrRefunded && (
        <Alert withoutIcon>Reservation transferred from : {purchase.transferredFromEmail}</Alert>
      )}
      {purchase?.inTransfer && purchase?.inTransferTo && (
        <Alert withoutIcon>Reservation transferred to : {purchase.inTransferTo.email}</Alert>
      )}
      {isDelivery && !reserveShippingTime && ticketType?.deliveryServiceProvider === 'DOORDASH' && (
        <Alert withoutIcon>
          <Typography variant="body02">
            {businessName} uses DoorDash couriers for delivery. The driver may contact you with
            updates regarding your order. For questions about your order please contact{' '}
            {businessName}. For all delivery related questions please call DoorDash support{' '}
            <a href="tel:+18559731040">(855) 973-1040</a>.
          </Typography>
        </Alert>
      )}
      {isDelivery &&
        !purchase?.cancelledOrRefunded &&
        !reserveShippingTime &&
        ticketType?.deliveryServiceProvider === 'POSTMATES' && (
          <Alert withoutIcon>
            <Typography variant="body02">
              {businessName} uses Uber couriers for delivery. The driver may contact you with
              updates regarding your order. For questions about your order please contact{' '}
              {businessName}. For all delivery related questions please call Uber support{' '}
              <a href="tel:+18669873750">(866) 987-3750</a>.
            </Typography>
          </Alert>
        )}
      {isDelivery && !reserveShippingTime && ticketType?.deliveryServiceProvider === 'INTERNAL' && (
        <Alert withoutIcon>
          <Typography variant="body02">
            You'll receive a confirmation email with details for your delivery order, and drivers
            will text you at the phone number you provided when your order arrives.
          </Typography>
        </Alert>
      )}
      {isDelivery && reserveShippingTime && (
        <Alert withoutIcon>
          <Typography variant="body02">
            You'll receive a confirmation email with details for your delivery order.
          </Typography>
        </Alert>
      )}
      {isPickup && (
        <Alert withoutIcon>
          <Typography variant="body02">
            You'll receive a confirmation email with details for your pickup order.
          </Typography>
        </Alert>
      )}
    </>
  );
};
